function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Dropdown"
}, /*#__PURE__*/React.createElement("path", {
  id: "Dropdown_2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.45013 13.7368C9.75501 14.0877 10.245 14.0877 10.5499 13.7368L16.7719 6.53712C17.076 6.18434 17.076 5.61557 16.7719 5.26459C16.4678 4.9118 15.9755 4.9118 15.6722 5.26459L10 11.8271L4.32782 5.26459C4.02372 4.9118 3.5314 4.9118 3.22808 5.26459C2.92397 5.61557 2.92397 6.18434 3.22808 6.53712L9.45013 13.7368Z",
  fill: "#4A4A4A",
  stroke: "#4A4A4A"
}));

function SvgDropdown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.ef39d753faa9e51d30c230f3996eb6b7.svg";
export { ForwardRef as ReactComponent };